import PanelSection from 'views/components/PanelSection';
import React from 'react';
import { Row } from 'reactstrap';
import { downloadHeaders } from './fixtures';
import { isLocked } from 'shared/utils';
import moment from 'moment';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    Card,
    InfoCard
} from 'mol-ui';
import {
    ColStyled,
    ContainerStyled,
    InfoComments,
    InfoRow,
    Message,
    Title
} from './styled';
import {
    StatisticsInfo,
    StatisticsLayout
} from 'views/components';
import {
    useDispatch,
    useSelector
} from 'hooks';

const StatisticsSurveys = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user } = useSelector('account');
    const {
        loading,
        surveys: {
            calls,
            calls_doctor_audio,
            calls_doctor_no_audio,
            calls_doctor_no_rating,
            calls_doctor_no_video,
            calls_doctor_video,
            calls_patient_audio,
            calls_patient_no_audio,
            calls_patient_no_rating,
            calls_patient_no_video,
            calls_patient_video,
            doctor_audio_percent,
            doctor_no_audio_percent,
            doctor_no_rating_percent,
            doctor_no_video_percent,
            doctor_quality_five_star,
            doctor_quality_four_star,
            doctor_quality_one_star,
            doctor_quality_three_star,
            doctor_quality_two_star,
            doctor_video_percent,
            doctors,
            patient_audio_percent,
            patient_no_audio_percent,
            patient_no_rating_percent,
            patient_no_video_percent,
            patient_quality_five_star,
            patient_quality_four_star,
            patient_quality_one_star,
            patient_quality_three_star,
            patient_quality_two_star,
            patient_session_five_star,
            patient_session_four_star,
            patient_session_one_star,
            patient_session_three_star,
            patient_session_two_star,
            patient_video_percent,
            patients,
            ratings = []
        },
        surveysDownload,
        surveysDownloading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsSurveys(filters));
    };

    const downloadController = {
        data: surveysDownload,
        downloading: surveysDownloading,
        fileName: t('Encuestas'),
        headers: downloadHeaders,
        onDownload: filters => dispatch(statisticsActions.getStatisticsSurveysDownload(filters))
    };

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            loading={ loading }
            title={ t('Encuestas') }
            onFiltersChange={ onFiltersChange }
        >
            <ContainerStyled fluid >
                <Row>
                    <ColStyled sm={ 4 } xs={ 12 }>
                        <InfoCard
                            caption={ t('Pacientes') }
                            icon="person"
                            title={ !!patients ? patients.toString() : '0' }
                        />
                    </ColStyled>
                    <ColStyled sm={ 4 } xs={ 12 }>
                        <InfoCard
                            caption={ t('Profesionales') }
                            icon="person"
                            title={ !!doctors ? doctors.toString() : '0' }
                        />
                    </ColStyled>
                    <ColStyled sm={ 4 } xs={ 12 }>
                        <InfoCard
                            caption={ t('Llamadas finalizadas') }
                            icon="done"
                            title={ !!calls ? calls.toString() : '0' }
                        />
                    </ColStyled>
                </Row>
                <Row>
                    <ColStyled sm={ 4 } xs={ 12 }>
                        <Card>
                            <PanelSection
                                title={ `${ t('Paciente') } - ${ t('Calidad') }` }
                            >
                                <StatisticsInfo
                                    info={ !!patient_quality_five_star ? patient_quality_five_star : '0' }
                                    text={ `5 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_quality_four_star ? patient_quality_four_star : '0' }
                                    text={ `4 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_quality_three_star ? patient_quality_three_star : '0' }
                                    text={ `3 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_quality_two_star ? patient_quality_two_star : '0' }
                                    text={ `2 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_quality_one_star ? patient_quality_one_star : '0' }
                                    text={ `1 ${ t('Estrella') }` }
                                />
                                <StatisticsInfo
                                    info={ !!calls_patient_no_rating ? calls_patient_no_rating : '0' }
                                    text={ t('No completado') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    <ColStyled sm={ 4 } xs={ 12 }>
                        <Card>
                            <PanelSection
                                title={ `${ t('Paciente') } - ${ t('Atención') }` }
                            >
                                <StatisticsInfo
                                    info={ !!patient_session_five_star ? patient_session_five_star : '0' }
                                    text={ `5 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_session_four_star ? patient_session_four_star : '0' }
                                    text={ `4 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_session_three_star ? patient_session_three_star : '0' }
                                    text={ `3 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_session_two_star ? patient_session_two_star : '0' }
                                    text={ `2 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!patient_session_one_star ? patient_session_one_star : '0' }
                                    text={ `1 ${ t('Estrella') }` }
                                />
                                <StatisticsInfo
                                    info={ !!calls_patient_no_rating ? calls_patient_no_rating : '0' }
                                    text={ t('No completado') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    <ColStyled sm={ 4 } xs={ 12 }>
                        <Card>
                            <PanelSection
                                title={ `${ t('Profesional') } - ${ t('Calidad') }` }
                            >
                                <StatisticsInfo
                                    info={ !!doctor_quality_five_star ? doctor_quality_five_star : '0' }
                                    text={ `5 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!doctor_quality_four_star ? doctor_quality_four_star : '0' }
                                    text={ `4 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!doctor_quality_three_star ? doctor_quality_three_star : '0' }
                                    text={ `3 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!doctor_quality_two_star ? doctor_quality_two_star : '0' }
                                    text={ `2 ${ t('Estrellas') }` }
                                />
                                <StatisticsInfo
                                    info={ !!doctor_quality_one_star ? doctor_quality_one_star : '0' }
                                    text={ `1 ${ t('Estrella') }` }
                                />
                                <StatisticsInfo
                                    info={ !!calls_doctor_no_rating ? calls_doctor_no_rating : '0' }
                                    text={ t('No completado') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                </Row>
                <Row>
                    <ColStyled xs={ 12 }>
                        <Card>
                            <Title>{ t('Encuestas completas con comentarios') }</Title>
                            {
                                ratings.length === 0
                                    ? <Message> { t('No se registraron comentarios') } </Message>
                                    : <InfoComments>
                                        {
                                            ratings.map(({ audio, call_id, comment, created_at, is_doctor, user_first_name, user_last_name, video }, index) => {
                                                const timestamp = moment(created_at).format('DD/MM/YYYY HH:mm');
                                                return (
                                                    <InfoRow key={ index }>
                                                        { `
                                                        
                                                            ${ comment.length > 0 &&
                                                                `N° ${ call_id } -
                                                                    ${ timestamp }: ${ user_last_name }, ${ user_first_name } -
                                                                    (${ !!is_doctor ? t('Profesional') : t('Paciente') }) -
                                                                    ${ t('Audio') }: ${ !!audio ? t('Si') : t('No') } -
                                                                    ${ t('Video') }: ${ !!video ? t('Si') : t('No') } -
                                                                    ${ t('Comentarios') }: ${ comment } ` }
                                                        ` }
                                                    </InfoRow>
                                                );
                                            })
                                        }
                                    </InfoComments>
                            }
                        </Card>
                    </ColStyled>
                </Row>
                <Row>
                    <ColStyled sm={ 3 } xs={ 12 }>
                        <Card>
                            <PanelSection
                                title={ `${ t('Paciente') } - ${ t('Audio') }` }
                            >
                                <StatisticsInfo
                                    info={ `${ !!calls_patient_audio ? calls_patient_audio : '0' } (${ !!patient_audio_percent ? Math.round(patient_audio_percent) : 0 }%)` }
                                    text={ t('Con audio') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_patient_no_audio ? calls_patient_no_audio : '0' } (${ !!patient_no_audio_percent ? Math.round(patient_no_audio_percent) : 0 }%)` }
                                    text={ t('Sin audio') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_patient_no_rating ? calls_patient_no_rating : '0' } (${ !!patient_no_rating_percent ? Math.round(patient_no_rating_percent) : 0 }%)` }
                                    text={ t('Sin completar') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    <ColStyled sm={ 3 } xs={ 12 }>
                        <Card>
                            <PanelSection
                                title={ `${ t('Paciente') } - ${ t('Video') }` }
                            >
                                <StatisticsInfo
                                    info={ `${ !!calls_patient_video ? calls_patient_video : '0' } (${ !!patient_video_percent ? Math.round(patient_video_percent) : 0 }%)` }
                                    text={ t('Con video') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_patient_no_video ? calls_patient_no_video : '0' } (${ !!patient_no_video_percent ? Math.round(patient_no_video_percent) : 0 }%)` }
                                    text={ t('Sin video') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_patient_no_rating ? calls_patient_no_rating : '0' } (${ !!patient_no_rating_percent ? Math.round(patient_no_rating_percent) : 0 }%)` }
                                    text={ t('Sin completar') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    <ColStyled sm={ 3 } xs={ 12 }>
                        <Card>
                            <PanelSection
                                title={ `${ t('Profesional') } - ${ t('Audio') }` }
                            >
                                <StatisticsInfo
                                    info={ `${ !!calls_doctor_audio ? calls_doctor_audio : '0' } (${ !!doctor_audio_percent ? Math.round(doctor_audio_percent) : 0 }%)` }
                                    text={ t('Con audio') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_doctor_no_audio ? calls_doctor_no_audio : '0' } (${ !!doctor_no_audio_percent ? Math.round(doctor_no_audio_percent) : 0 }%)` }
                                    text={ t('Sin audio') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_doctor_no_rating ? calls_doctor_no_rating : '0' } (${ !!doctor_no_rating_percent ? Math.round(doctor_no_rating_percent) : 0 }%)` }
                                    text={ t('Sin completar') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    <ColStyled sm={ 3 } xs={ 12 }>
                        <Card>
                            <PanelSection
                                title={ `${ t('Profesional') } - ${ t('Video') }` }
                            >
                                <StatisticsInfo
                                    info={ `${ !!calls_doctor_video ? calls_doctor_video : '0' } (${ !!doctor_video_percent ? Math.round(doctor_video_percent) : 0 }%)` }
                                    text={ t('Con video') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_doctor_no_video ? calls_doctor_no_video : '0' } (${ !!doctor_no_video_percent ? Math.round(doctor_no_video_percent) : 0 }%)` }
                                    text={ t('Sin video') }
                                />
                                <StatisticsInfo
                                    info={ `${ !!calls_doctor_no_rating ? calls_doctor_no_rating : '0' } (${ !!doctor_no_rating_percent ? Math.round(doctor_no_rating_percent) : 0 }%)` }
                                    text={ t('Sin completar') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                </Row>
            </ContainerStyled>
        </StatisticsLayout>
    );
};

StatisticsSurveys.propTypes = {

};

export default StatisticsSurveys;
